'use strict';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { EaselPlugin } from 'gsap/EaselPlugin';
gsap.registerPlugin(EaselPlugin, ScrollTrigger);

export function slideUpLetters(targets) {
  for (const letter of targets) {
    letter.spans = letter.querySelectorAll('span');
  }
  const slideUpLettersSet = {
    display: 'inline-block',
    // overflow: 'hidden',
    opacity: 0,
    y: '100%',
    duration: 3,
    ease: 'power2.out',
  };
  const slideUpLettersTo = {
    opacity: 1,
    y: 0,
    stagger: 0.1,
  };
  targets.forEach((item, index) => {
    const child = item.getElementsByTagName('span');
    gsap.set(child, slideUpLettersSet);
    gsap.to(child, {
      ...slideUpLettersTo,
      scrollTrigger: {
        trigger: item,
        start: 'top 85%',
      },
    });
  });
}
export function slideleftLetters(targets) {
  for (const Letter of targets) {
    Letter.spans = Letter.querySelectorAll('span');
  }
  const slideLeftLetterSet = {
    display: 'inline-block',
    // overflow: 'hidden',
    opacity: 0,
    x: 20,
    duration: 3,
    ease: 'power2.out',
  };
  const slideLeftLetterTo = {
    opacity: 1,
    x: 0,
    stagger: 0.1,
  };
  targets.forEach((item, index) => {
    const child = item.getElementsByTagName('span');
    gsap.set(child, slideLeftLetterSet);
    gsap.to(child, {
      ...slideLeftLetterTo,
      scrollTrigger: {
        trigger: item,
        start: 'top 90%',
      },
    });
  });
}

// 固定ページkv用
export function initLayerPageKv() {
  // const kvWing = document.querySelectorAll('.page-kv__bg');
  const slideUpTarget = document.querySelectorAll('.page-kv-title__en');
  const initLayerKvtl = gsap.timeline();
  initLayerKvtl
    // .set(kvWing, {
    //   opacity: 0,
    // })
    // kvクリップ
    // .add(() => {
    //   document.querySelector('.page-kv').classList.add('is-active');
    // }, 'start')
    // enタイトル下から
    .add(slideUpLetters(slideUpTarget), 'start')
    // テキストの右上羽生える
    .add(() => {
      document
        .querySelector('.handwritingText__maskLine')
        .classList.add('is-active');
    }, '+=.5')
    // 右側の大きい羽表示
    // .to(kvWing, {
    //   duration: 1,
    //   opacity: 1,
    // })
    // 日本語タイトル右から左
    .add(() => {
      document.querySelector('.page-kv-title__ja').classList.add('is-active');
    }, '+=0.5')
    // パンくず表示
    .add(() => {
      document.querySelector('.page-breadcrumb').classList.add('is-active');
    }, '<');

  // 3秒くらい？
}

// ガイドライン系kv
export function initGuidelineKv() {
  const slideLeftTarget = document.querySelectorAll('.guideline-kv-title__en');
  const initGuidelineKvtl = gsap.timeline();
  initGuidelineKvtl
    // enタイトル下から
    .add(slideleftLetters(slideLeftTarget), 'start')
    // 日本語タイトル右から左
    .add(() => {
      document
        .querySelector('.guideline-kv-title__ja')
        .classList.add('is-active');
    }, '+=1')
    // パンくず表示
    .add(() => {
      document
        .querySelector('.guideline-kv__breadcrumb')
        .classList.add('is-active');
    }, '<');

  // 3秒くらい？
}
// ロゴが流れるセクション
export function flowBlockLoop() {
  const flowBlocks = document.querySelectorAll('.flow-block__line');

  flowBlocks.forEach((flowBlock) => {
    const flowItemWraps = Array.from(
      flowBlock.querySelectorAll('.flow-item-wrap')
    );

    flowItemWraps.forEach((wrap) => {
      const lines = wrap.querySelectorAll('.clients-line');
      const logoCount = lines.length;

      // アニメーション時間を計算
      // ロゴの数 * 1秒
      const wrapDuration = logoCount * 2;

      const resetWrap = () => {
        wrap.style.transform = 'none';
      };

      const wrapAnimation = gsap.to(wrap, {
        xPercent: -100,
        duration: wrapDuration,
        repeat: -1,
        onRepeat: resetWrap,
        ease: 'none',
      });
    });
  });
}
